import React from 'react';

import Star from 'url:./resources/Star.png';
import IStar from 'url:./resources/IStar.png';
import AStar from 'url:./resources/AStar.png';
import Block from 'url:./resources/Block.png';

interface DifficultyDisplayProps {
	difficulty?: number;
}

const difficultyToImage = (difficulty: number) => {
	if(difficulty <= 3){
		return Star;
	} else if(difficulty <= 7){
		return IStar;
	} else if(difficulty <= 10){
		return AStar;
	} else {
		return Block;
	}
}

const difficultyAltText = (difficulty: number) => {
	if(difficulty <= 3){
		return 'Beginner Block';
	} else if(difficulty <= 7){
		return 'Intermediate Block';
	} else if(difficulty <= 10){
		return 'Advanced Block';
	} else {
		return 'Unknown Difficulty';
	}
}

export default function DifficultyDisplay({ difficulty }: DifficultyDisplayProps) {
	if (!difficulty) {
		return <span>Not rated</span>;
	}

	return (
		<div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
			Difficulty {difficulty}
			<img 
				src={difficultyToImage(difficulty)} 
				alt={difficultyAltText(difficulty)}
				style={{ width: '20px', height: '20px' }}
			/>
		</div>
	);
}

